export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20flat%20lay%20arrangement%20featuring%20premium%20sneakers%20luxury%20handbag%20designer%20watch%20and%20stylish%20accessories%20on%20a%20warm%20cream%20marble%20surface%20surrounded%20by%20soft%20natural%20lighting%20from%20a%20large%20window%20with%20sheer%20curtains%20gentle%20shadows%20editorial%20fashion%20magazine%20style%20clean%20fresh%20aesthetic%20with%20sage%20green%20and%20warm%20beige%20accents%20subtle%20texture%20background%20no%20text%20no%20people%20professional%20ecommerce%20photography%20soft%20diffused%20light%20luxury%20retail%20atmosphere&width=1800&height=900&seq=hero-superbuy-v2-product&orientation=landscape"
        alt="Superbuy Spreadsheet organized product discovery"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/25"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 mb-6">
          <i className="ri-sparkling-2-fill text-accent-500 text-sm"></i>
          <span className="text-white/90 text-xs font-medium">Updated for 2026</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          Superbuy Spreadsheet
          <br />
          <span className="text-white/80 text-2xl md:text-4xl lg:text-5xl font-normal italic">
            The Ultimate Product Finding &amp; Shopping Resource
          </span>
        </h1>

        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-9 leading-relaxed">
          Discover thousands of organized product finds, shopping guides, comparisons, QC resources and expert tips with the most complete Superbuy Spreadsheet platform. Your gateway to smarter international shopping starts here.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40"
          >
            Superbuy Sheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white text-foreground-900 text-base font-semibold whitespace-nowrap hover:bg-white/90 transition-all duration-200"
          >
            Buy It Now
            <i className="ri-shopping-bag-line ml-2"></i>
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10 flex-wrap">
          {[
            { icon: 'ri-check-line', text: 'Updated Product Resources' },
            { icon: 'ri-check-line', text: 'Organized Shopping Guides' },
            { icon: 'ri-check-line', text: 'Detailed Comparisons' },
            { icon: 'ri-check-line', text: 'Beginner Friendly' },
            { icon: 'ri-check-line', text: 'Secure Browsing' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-1.5 text-white/70 text-xs">
              <i className={item.icon}></i>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}